module.exports = __webpack_public_path__ + "img/leakinstreet_attached.0f33e00f.svg";